import { gql } from '@parkchirp/api-client';

export const GET_USER_EXISTS_V2 = gql`
    query getUserExists(
        $email: String!
    ) {
        getUserExists(
            email: $email
        )
    }
`;

export const VALIDATE_PAYORS_EMAILS_PRESENT_IN_COGNITO_AND_DB = gql`
    query validatePayorsEmailsPresentInCognitoAndDB(
        $emails: [String]!
    ) {
        validatePayorsEmailsPresentInCognitoAndDB(
            emails: $emails
        ) {
            email
            foundInCognito
            foundInUsersTable
        }
    }
`;
